// extracted by mini-css-extract-plugin
export default {"container":"conversation-list_container__Q-J5w","list":"conversation-list_list__0kFvZ"};